// extracted by mini-css-extract-plugin
export default {"user-form":"UserForm_user-form__L+Z5J","subtitle":"UserForm_subtitle__adyzA","error":"UserForm_error__FfSVx"};